import { mediaData } from '@/mocks/home';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20thumbnail%20of%20Chinese%20singing%20competition%20performance%20stage%20with%20dramatic%20lighting%20warm%20amber%20cream%20tones%2C%20clean%20professional%20aesthetic%2C%20editorial%20style&width=800&height=500&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20thumbnail%20of%20esports%20arena%20epic%20moments%20highlights%20with%20warm%20amber%20cream%20tones%2C%20clean%20professional%20aesthetic%2C%20editorial%20style&width=800&height=500&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20thumbnail%20of%20academic%20conference%20thesis%20defense%20presentation%20with%20warm%20amber%20cream%20tones%2C%20clean%20professional%20aesthetic%2C%20editorial%20style&width=800&height=500&seq=media-03&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">精彩回顾</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {mediaData.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-secondary-200/60 cursor-pointer transition-all duration-200">
              <div className="relative w-full h-52 overflow-hidden bg-background-200">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  title={`51大赛 - ${item.title}`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e: React.SyntheticEvent<HTMLImageElement>) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 text-[10px] font-medium bg-background-950/60 text-background-50 rounded whitespace-nowrap">{item.duration}</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-secondary-600 transition-colors line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}